<template>
    <Section width="md">
        <div class="container bank-cooperations">
            <div 
                v-if="$validateText(slice.primary.title)"
                class="bank-cooperations-title"
                v-html="$prismic.asHtml(slice.primary.title)" 
            />
            <div class="bank-cooperations-box">
                <prismic-link 
                    v-for="(item, index) in items"
                    :key="index" 
                    :link="item.link"
                    class="bank-cooperations-item"
                >
                    <prismic-image
                        class="bank-cooperations-img"
                        :img="item.image"
                        w="55"
                        h="55"
                    />
                    <span v-if="item.label" class="label">{{ item.label }}</span>
                </prismic-link>
            </div>
        </div>
    </Section>
</template>
<script>
import PrismicLink from '@/components/PrismicLink.vue';
export default {
    components: {
        PrismicLink
    },
    props: {
        slice: {
            type: Object,
            required: true
        }
    },
    computed: {
        items() {
            return this.slice.items
                .filter(data => data.bank_image?.url)
                .map(item => {
                    return {
                        image: item.bank_image,
                        label: item.label,
                        link: item.link,
                    };
                });
        }
    }
};
</script>
<style lang='scss' scoped>
    .bank-cooperations {

        .bank-cooperations-title {
            text-align: center;
            margin-bottom: 2rem;
            @include device(pad) {
                margin-bottom: 3rem;
            }
        }

        div.bank-cooperations-box {
            display: flex;
            flex-wrap: wrap;
            max-width: 100%;
            justify-content: center;
            align-items: stretch;
            text-align: center;
            row-gap: 1rem;
            @include device(pad) {
                row-gap: 3rem;
                width: 100%;
                max-width: 550px;
                justify-self: center;
            }
            @include device(desktop) {
                max-width: 100%;
            }
        
            .bank-cooperations-item {
                flex: 0 0 auto;
                width: 33.33333333%;
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 1rem;
                @include spacing(padding,1,(left,right));
                @include device(desktop) {
                    width: auto;
                    min-width: 130px;
                }
                .bank-cooperations-img {
                    object-fit: contain;
                }
                span {
                    font-weight: bold;
                    font-family: $fontText;
                    color: $font;
                    @include device(mobile) {
                        @include font-size(14px);
                    }
                }

            }
            a:hover {
                span {
                    color: $pink;
                }
            }
        }
    }
</style>